import { accountAPI } from "services";
import Parse from "./parse.service";


export const addReminder = async (accountId, date, isEnabled) => {
  const account = await accountAPI.getAccountById(accountId);
  if (!account) throw new Error("Account not found");

  const reminder = {
    enabled: isEnabled,
    date: date
  };

  account.set("reminder", reminder);
  await account.save();
  return await accountAPI.getAccounts();
};

//toggle the enabled column based on account Id
export const toggleReminder = async (accountId, isEnabling) => {
  const account = await accountAPI.getAccountById(accountId);
  if (!account) throw new Error("Account not found");

  const reminder = account.get("reminder") || {};
  reminder.enabled = isEnabling;

  account.set("reminder", reminder);
  await account.save();
  return await accountAPI.getAccounts();
};

//fetch the reminder data for a specific account 
export const fetchReminder = async (accountId) => {
  try {
    const account = await accountAPI.getAccountById(accountId);
    if (!account) return null;

    const reminderData = account.get("reminder");
    if (!reminderData) return null;

    return [account];
  } catch (error) {
    console.error("fetchReminder Error: ", error);
    return [];
  }
};

export const updateReminder = async (accountId, date) => {
  try {
    const account = await accountAPI.getAccountById(accountId);
    if (!account) throw new Error("Account not found");

    const reminder = account.get("reminder") || {};
    reminder.date = date;
    reminder.enabled = true;

    account.set("reminder", reminder);
    await account.save();
    return await accountAPI.getAccounts();
  } catch (error) {
    console.error("updateReminder error: ", error);
    throw error;
  }
};

export const deleteReminder = async (accountId) => {
  try {
    const account = await accountAPI.getAccountById(accountId);
    if (account) {
      account.unset("reminder");
      await account.save();
      return await accountAPI.getAccounts();
    }
    return [];
  } catch (error) {
    console.error("deleteReminder error: ", error);
    return [];
  }
};

export const getOverdueAccounts = async () => {
  try {
    const accounts = await accountAPI.getAccounts();
    const now = new Date();
    const overdue = accounts.filter(acc => {
      const reminder = acc.get("reminder");
      return reminder?.date && new Date(reminder.date) < now;
    });
    return overdue;
  } catch (error) {
    console.error("getOverdueAccounts error: ", error);
    return [];
  }
};
